<template>
  <v-layout
    :title="$t('site_contact.title')"
    :subtitle="$t('site_contact.subtitle')"
  >

    <ContactForm />
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";
import ContactForm from "@/components/ContactForm";

export default {
  name: "site-contact",
  components: {
    VLayout,
    ContactForm,
  },
  data() {
    return {};
  },
  fallbackI18n: {
    messages: {
      und: {
        site_contact: {
          title: "Contact",
          subtitle:
            "To get in touch, fill out the form. We will answer you shortly!",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
